module.exports = __webpack_public_path__ + "images/78aa2547fe1eabee69ea47e90db5fa78-BVI.png";